import { AddFileRequest } from './add-file-request';
export class AddEventFileRequest {
  eventId: number;
  isImage: boolean;
  fileRequest: AddFileRequest;

}
